// Place names on the page in the reader's language (docs/i18n.md "Place names"). The map data keeps each place's
// Chinese name as `name` and its other languages in `names` (deck/map.js: the Tiled property name_en; a room built in
// the map editor: the English name its editor gave it, or the default name's, map-overlay.js applyOverlay). The office
// and agents keep using the Chinese `name`; on the page, `name` is the reader's language: localizePlaces sets it on
// every named place of a map, and again when the language changes (so every view that reads `.name` follows).
// A name with no `names` (one somebody typed: a room, a floor) is shown as it is, in every language.
import { lang, onLang } from '/i18n.js';

const LISTS = ['zones', 'seats', 'tables', 'cardTables', 'whiteboards', 'portals', 'kiosks'];
/** A place's name in the reader's language (its Chinese name when it has none in that language). */
export function placeName(o) {
  if (!o?.names) return o?.name ?? '';
  return o.names[lang] ?? o.names['zh-CN'] ?? o.name;
}
/** Put the reader's language in `name` of every place in these maps that has `names` (the Chinese one kept as
 *  names['zh-CN']). Cheap; safe to call again (after a map edit: deck/map-editor-view.js refreshMap). */
export function localizePlaces(...maps) {
  for (const map of maps) for (const k of LISTS) for (const o of map?.[k] ?? []) {
    if (!o?.names) continue;
    o.names['zh-CN'] ??= o.name;
    o.name = placeName(o);
  }
}
const watched = new Set();
/** localizePlaces now, and on every language change from here on. */
export function keepPlacesLocalized(...maps) {
  for (const m of maps) if (m) watched.add(m);
  localizePlaces(...maps);
}
onLang(() => localizePlaces(...watched));
